<script>
  import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
  import { Link } from "svelte-routing";
  import Confetti from "../components/Confetti.svelte";
  import Container from "../components/Container.svelte";
  import Icon from "../components/Icon.svelte";
  import Section from "../components/Section.svelte";
</script>

<Confetti />

<Section bgColor="dark-grey">
  <Container>
    <h1>Congratulations</h1>

    <p>Thanks so much for taking this learning journey with PeopleStorming</p>

    <img alt="hooray" height="225" src="/img/hooray.gif" width="400" />
  </Container>
</Section>

<Section>
  <Container>
    <h2>The Road Ahead</h2>
    <p>
      We've enjoyed every moment with you and hope you'll use the things you've
      learned for many years to come.
    </p>
    <p>
      We'd love to stay connected so we can hear all about how you're doing...
    </p>
    <p>
      <a
        class="button is-gold is-medium"
        href="https://www.linkedin.com/company/peoplestorming/"
        target="_blank"
        rel="noopener"
      >
        <Icon i={faLinkedin} />
        Follow us on LinkedIn
      </a>
    </p>
    <p class="explore">
      To continue exploring, check out our
      <Link to="/blog">blog</Link> and
      <Link to="/leadership-resource-list">leadership resources</Link>.
    </p>
  </Container>
</Section>

<style>
  a.button {
    gap: 1rem;
  }

  .explore {
    margin-top: 2rem;
  }

  .explore :global(a) {
    text-decoration-line: underline;
  }
</style>
